const PromotionsBackend = {
  invoke: {
    startPromotions: async ([socketId, viewMode]: [string, string]) => {
      const state = await getPromotionsState();

      if (state === 'STOPPED') {
        return window.WH.bootstrapper!.features['promotions-flow'].start({
          containerSelector: `#${socketId}`,
          viewMode,
        });
      }
    },

    stopPromotions: async () => {
      const state = await getPromotionsState();

      if (state !== 'STOPPED') {
        window.WH.bootstrapper!.features['promotions-flow'].stop();
      }
    },

    showPromotionsList: async ([locale]: [string]) => {
      const state = await getPromotionsState();

      if (state !== 'STOPPED') {
        window.WH.bootstrapper!.features['promotions-flow'].showList({
          promotionLangCode: locale,
        });
      }
    },

    showPromotionsDetails: async ([slug, locale]: [string, string]) => {
      const state = await getPromotionsState();

      if (state !== 'STOPPED') {
        window.WH.bootstrapper!.features['promotions-flow'].showDetails({
          promotionSlug: slug,
          promotionLangCode: locale,
        });
      }
    },
  },
};

const getPromotionsState = async () => {
  const { state } = await window.WH.bootstrapper!.features[
    'promotions-flow'
  ].getState();

  return state;
};

export default PromotionsBackend;
